import { defineMessages } from 'react-intl';

export const i18n: {
	commentIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	commentIconLabel: {
		id: 'search-page.comment-icon-label',
		defaultMessage: 'Comment',
		description:
			'Accessible label for the comment icon displayed next to the comment count on a search result.',
	},
});
